//import React from "react";
import React, { useState, useEffect, useContext} from 'react';
import { useTranslation } from 'react-i18next';

// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/icons
import PersonIcon from '@material-ui/icons/Person';
import Edit from "@material-ui/icons/Edit";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import { SessionContext } from "beaktShared/services/session";
import Badge from "beaktShared/components/Badge/Badge.js";

import { useGetApi, UseGetApiSimple, UsePostApi, UsePutApi,UseDeleteApi } from "beaktShared/services/crudeApiService";
import UsuarioForm from "./UsuarioForm";

import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);


export default function UsuarioList() {
    const { t } = useTranslation(); 

    const session = useContext(SessionContext);

    const endPoint = 'usuarios';  
   
    const [showFormView, setshowFormView] = React.useState(false);
    const [item, setItem] = useState({});          
    const [loadingForm, setLoadingForm] = React.useState(false);

    const getEndPoint = () => {
        if (session.estabelecimentoId != 0)
            return  endPoint + "/bycadastroestabelecimento/" + session.estabelecimentoId;    
        else
            return  endPoint + "/bycadastrofranquia/" + session.franquiaId;
    }
    const [{list, isLoadingList, isErrorGetList}, setListAtualiza] = useGetApi(getEndPoint());
    
    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');    
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    const showNotification = (mensagem,color) => { 
        setMensagemNotification(mensagem);
        setColorNotification(color);      
        setNotification(true);
        setTimeout(function() {
            setNotification(false);
        }, 6000);       
    };
  
    const handleAdd = item => {                    
        var vefifyExists = list.filter(obj => {
            return obj.usuarioId.toString() === item.usuarioId.toString();
        });

        setLoadingForm(true);
        UsePostApi(endPoint + "/save/" + session.estabelecimentoId,item).then(result=>{                
            setLoadingForm(false);  
            if(result.status !== 201)
            {                                     
                showNotification(result.message.message,'danger');
                return false; 
            } 

            let newlist = [];
            if (vefifyExists.length > 0)            
                newlist = list.map(l => (l.usuarioId.toString() === result.data.usuarioId.toString() ? result.data : l));                            
            else
                newlist = [...list, result.data];
            
            setListAtualiza(newlist);            
            
            handleView(true);
            showNotification(t('information_message.registered_successfully'),'success');
            return true;                
        }); 
    };   

    const handleView = (resetItem) => {            
        if(resetItem)
            setItem({});
        let show = showFormView === true ? false : true;
        setshowFormView(show);             
    };

    const handleEdit = row => {       
        UseGetApiSimple("usuarios/bycadastro/" + row.usuarioId,0).then(result => {
            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');
                return false; 
            }
            setItem(result.data);
            handleView(false);
        });        
    };
    
    const columnsProp = [
        {
            Header: t('label.name'),
            accessor: "nome"
        },
        {
            Header: t('sidebar.profile'),
            accessor: "perfilUsuario.tipoPerfilDesc"
        },
        {
            Header: t('login.login'),
            accessor: "login"
        },
        {
            Header: t('label.status'),
            accessor: "ativo",
            Cell: (row) => { 
                let color = "success";
                if (row.original.ativo == true)
                    return <span><Badge color="success">{t('label.active')}</Badge></span>
                else
                    return <span><Badge color="danger">{t('label.inactive')}</Badge></span>                
            },
        }
    ]
    const columnsAcao = [        
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">                        
                <Button
                    justIcon
                    round
                    simple
                    color="success"
                    className="edit"
                    onClick={() => handleEdit(row.original)}
                >
                <Tooltip title={t('label.to_edit')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Edit />
                </Tooltip>
                </Button>{" "}                
            </div>
            ),
            sortable: false,
            filterable: false
        }
    ];
    const columns = [...columnsProp,...columnsAcao]

    const classes = useStyles();
    return (
        <div>

            <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
            />

            {showFormView && 
                <UsuarioForm addItem={handleAdd} item={item} handleView={handleView} loading={loadingForm} />} 
            
            {!showFormView &&
                <GridContainer>            
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <PersonIcon />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('label.user_list')}</h4>
                        </CardHeader>
                        <CardBody>
                            <Button
                                color="primary"
                                className={classes.newButton}
                                onClick={() => handleView(true)}
                            >
                                {t('button.new')}
                            </Button>                           

                            {isErrorGetList && <div>{t('error_message.loading_error')}</div>}
                            <ReactTable
                                loading = {isLoadingList}
                                data={list}
                                filterable
                                defaultFilterMethod = {noCaseSensitive}
                                columns={columns}
                                defaultPageSize={10}
                                minRows={5}
                                showPaginationBottom={true}
                                className="-striped -highlight"
                                previousText={t('button.previous')}
                                nextText={t('button.next')}
                                loadingText={t('label.loading')+"..."}
                                noDataText={t('information_message.no_records_found')+"!"}
                                pageText={t('label.page')}
                                ofText={t('label.of')}
                                rowsText={t('label.rows')}
                            />
                        </CardBody>
                    </Card>
                </GridItem>            
            </GridContainer>
            }                        
        </div>
    );
}
